import { render, staticRenderFns } from "./UpdateAccountInsurancePolicies.vue?vue&type=template&id=cb59c63a&"
import script from "./UpdateAccountInsurancePolicies.vue?vue&type=script&lang=js&"
export * from "./UpdateAccountInsurancePolicies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports